import React, {Component, PropTypes} from 'react';
import Immutable from 'immutable';
import {autobind} from 'core-decorators';
import {Field, Select, TextInput} from 'components/forms';
import {loadConfigurations, updateConfiguration, createConfiguration, deleteConfiguration} from './api';

@autobind
export default class Configurations extends Component {
    static propTypes = {
        onChange: PropTypes.func,
        onReset: PropTypes.func,
        getValues: PropTypes.func,
    };

    state = {
        name: '',
        selected: undefined,
        configurations: Immutable.List(),
        disable: [],
        loading: false,
    };

    componentWillMount() {
        this.loadConfigurations();
    }

    getListOptions() {
        return Immutable.fromJS([
            {value: 'new', label: 'New'},
            ...this.state.configurations.map(config => ({
                value: config.get('id'),
                label: config.get('name'),
            })),
        ]);
    }

    async loadConfigurations() {
        this.setState({loading: true});
        const configurations = await loadConfigurations();
        this.setState({configurations, loading: false});
    }

    handleConfigChange(value) {
        this.setState({selected: value});
        if (['', 'new'].includes(value)) this.props.onReset();
        if (this.props.onChange) {
            const selected = this.state.configurations.find(config => config.get('id') === value);
            if (selected) this.props.onChange(selected.get('values'));
        }
    }

    async handleUpdate() {
        this.setState({disable: ['update', 'duplicate']});
        await updateConfiguration({
            id: this.state.selected,
            values: this.props.getValues(),
        });
        this.loadConfigurations();
        this.setState({disable: []});
    }

    async handleDelete() {
        this.setState({disable: ['update', 'duplicate']});
        // eslint-disable-next-line no-alert
        if (window.confirm('Are you sure you want to delete the selected configuration?')) {
            await deleteConfiguration({id: this.state.selected});
            this.loadConfigurations();
        }
        this.setState({disable: []});
    }

    async handleDuplicate() {
        this.setState({selected: 'new', name: ''});
    }

    async handleCreate() {
        this.setState({disable: ['create', 'cancel']});
        const created = await createConfiguration({
            name: this.state.name,
            values: this.props.getValues(),
        });
        await this.loadConfigurations();
        this.setState({selected: created.get('id'), name: '', disable: []});
    }

    async handleCancel() {
        this.props.onReset();
        this.setState({selected: undefined});
    }

    handleNameChange(name) {
        this.setState({name});
    }

    render() {
        if (this.state.loading) return null;

        const renderSaveActions = ![undefined, 'new'].includes(this.state.selected);
        const renderCreateActions = ['new'].includes(this.state.selected);

        return (
            <div className='configurations'>
                <Field label='Configuration'>
                    <Select
                        placeholder='Select a configuration'
                        clearable={true}
                        options={this.getListOptions()}
                        onChange={this.handleConfigChange}
                        value={this.state.selected}
                    />
                </Field>
                {renderSaveActions && (
                    <div className='actions'>
                        <button
                            type='button'
                            className='button'
                            onClick={this.handleDelete}
                            disabled={!this.state.selected || this.state.disable.includes('delete')}
                        >
                            Delete
                        </button>
                        <button
                            type='button'
                            className='button'
                            onClick={this.handleUpdate}
                            disabled={!this.state.selected || this.state.disable.includes('update')}
                        >
                            Save
                        </button>
                        <button
                            type='button'
                            className='button'
                            onClick={this.handleDuplicate}
                            disabled={!this.state.selected || this.state.disable.includes('duplicate')}
                        >
                            Save as new
                        </button>
                    </div>
                )}
                {renderCreateActions && (
                    <div className='create'>
                        <Field label='Name'>
                            <TextInput grow={true} onChange={this.handleNameChange} />
                        </Field>
                        <div className='actions'>
                            <button
                                type='button'
                                className='button'
                                onClick={this.handleCancel}
                                disabled={this.state.disable.includes('cancel')}
                            >
                                Cancel
                            </button>
                            <button
                                type='button'
                                className='button'
                                onClick={this.handleCreate}
                                disabled={!this.state.name || this.state.disable.includes('create')}
                            >
                                Create
                            </button>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/test-page/configurations.js